// extracted by mini-css-extract-plugin
export default {"logo":"b2mbP","carousel":"G+Fri"};